// ----------------------------------------------------------------------
// <copyright file="Izenda.FullScreenButton.jsx" company="Izenda"> Copyright (c)
// 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var PropTypes = React.PropTypes;
  var ObservablePropTypes = require('mobx-react').propTypes;
  var connect = require('share/enhancers/Izenda.Connect');

  var FullScreenButton = connect()(function (props) {
    var dashboardPart = props.dashboardPart;
    var localization = props.localization;

    var fullScreenIcon = dashboardPart.isFullScreenMode
      ? { className: 'icon-nofullscreen', label: localization.getText('DASHBOARD_TITLE_NORMAL_SCREEN') }
      : { className: 'icon-fullscreen', label: localization.getText('DASHBOARD_TITLE_FULL_SCREEN') };

    return (
      <a
        className="btn u_noBorderAll"
        title={fullScreenIcon.label}
        onClick={dashboardPart.toggleFullScreenMode.bind(dashboardPart)}>
        <i className={fullScreenIcon.className}/>
        { props.showLabel && <span>{fullScreenIcon.label}</span>}
      </a>
    );
  });

  FullScreenButton.propTypes = {
    dashboardPart: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = FullScreenButton;
}();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Header/Izenda.FullScreenButton.jsx